<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="login-field" type="text" v-checkenter="login" v-model="username" :placeholder="placeholder ? placeholder : 'CODE'">
        </div>
        <div class="field-wrapper" v-if="usePassword">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" v-checkenter="login" type="password" v-model="password">
        </div>
        <input class="login-button" type="button" value="ENTRAR" @click.prevent="login">
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    export default {
        name: 'CodeLogin',

        props: {
            usePassword: true,
            placeholder: null
        },

        data ()
        {
            return {
                username: '',
                password: ''
            }
        },

        methods: {
            
            async login ()
            {
                this.username = this.username.toLowerCase().trim();
                this.password = this.password.trim();

                if (!this.usePassword) this.password = this.username;

                if (this.username && this.password)
                {
                    api
                        .post(`event/${this.$store.state.eventId}/loginCode`, { password: await encrypt(this.password), code: this.username })
                        .then(response => {
                            this.$emit('logged', response);
                        })
                        .catch(err => {
                            this.$emit('error', 'fail');
                        });
                }
                else
                {
                    // show error
                    this.$emit('error', 'fail');
                }
            }
        }
        
    }
</script>

<style lang="scss">
    
</style>